import cn from 'classnames'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { FinalizeAlert } from 'partner360/components/QBR/shared/finalizeAlert/FinalizeAlert'
import {
  selectIsQbrDocumentFinalized,
  selectUnpopulatedFieldsMessages,
} from 'partner360/features/QBR'

import { selectIsQbrChanged } from '../../../steps/settingsStep/components/qbrSettingsForm'

import { UnpopulatedData } from './components/unpopulatedData/UnpopulatedData'
import { UnsavedChanges } from './components/unsavedChanges/UnsavedChanges'

import styles from './QbrDocumentDetailsMessage.module.scss'

export const QbrDocumentDetailsMessage: FC = () => {
  const unpopulatedMessages = useSelector(selectUnpopulatedFieldsMessages)
  const isQbrFormChanged = useSelector(selectIsQbrChanged)
  const isFinalized = useSelector(selectIsQbrDocumentFinalized)

  if (isFinalized) {
    return (
      <div className={styles.root}>
        <div className={cn(styles.divider, styles.warning)} />
        <FinalizeAlert />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <div
        className={cn(styles.divider, {
          [styles.warning]: unpopulatedMessages.length > 0 || isQbrFormChanged,
        })}
      />
      {unpopulatedMessages.length > 0 && (
        <UnpopulatedData translationMessages={unpopulatedMessages} />
      )}
      {isQbrFormChanged && unpopulatedMessages.length === 0 && <UnsavedChanges />}
    </div>
  )
}
